import type { Feature } from './feature'

export class Selectors {
  public readonly context

  constructor(feature: Feature) {
    this.context = feature.state.project(state => state.context)
  }
}
